import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.667 6.667H1.333m6 2.667H4M1.333 5.467v5.067c0 .746 0 1.12.146 1.405.127.25.331.455.582.582.285.146.659.146 1.406.146h9.066c.747 0 1.12 0 1.406-.146.25-.127.454-.331.582-.582.146-.285.146-.659.146-1.405V5.467c0-.747 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.146-.659-.146-1.406-.146H3.467c-.747 0-1.12 0-1.406.146-.25.128-.455.332-.582.583-.146.285-.146.658-.146 1.405" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }